import { createAsyncThunk } from "@reduxjs/toolkit";
import { triggerAlert } from "redux/reducers/appSlice";

import lessonsService from "services/lessons";
import expertsService from "services/experts";
import {
  translateAPIMessage,
  translateFrontEndAlerts,
} from "../../utils/translation";
import { AppThunk } from "../store";
import { setLessonDetails, cleanDetails } from "redux/reducers/lessonsSlice";

export const getLessons = createAsyncThunk(
  "get/lessons",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await lessonsService.getLessons();
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getReservedLessons = createAsyncThunk(
  "get/reserved/lessons",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await lessonsService.getReservedLessons();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const publishUnpublishLesson = createAsyncThunk(
  "publishUnpublish/Lesson",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await lessonsService.publishUnpublishLesson(data);
      dispatch(getLessons());
      return response.data;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const createLessons = createAsyncThunk(
  "create/Lesson",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await lessonsService.createLessons(data.data);
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(16001),
        })
      );
      if (data.callback) {
        data.callback();
      }
      // return response.data;
      return true;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
      // return rejectWithValue(error);
      return false;
    }
  }
);

export const updateLessons = createAsyncThunk(
  "update/Lesson",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      await lessonsService.updateLessons(data.data);
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(16002),
        })
      );
      if (data.successCallback) {
        data.successCallback();
      }
      return true;
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message as number;
      const lessonName = error?.response?.data?.errors?.lesson_name;
      const attribute = lessonName ? { lessonName } : undefined;
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(errorMessage, attribute)
            || translateFrontEndAlerts(11001),
        })
      );
      if (data.failureCallback) {
        data.failureCallback();
      }
      return rejectWithValue(error);
    }
  }
);

// * get lesson by id
export const getLessonById = createAsyncThunk(
  "get/lesson/by/id",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await lessonsService.getLessonById(data);
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const getLessonByLessonId = createAsyncThunk(
  "get/lessonByLessonId",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await lessonsService.getLessonByLessonId(data);
      const expertDetails = await expertsService.getTeacherById(
        res.data.lesson.expert_id
      );
      return { res, expertDetails };
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);
export const teacherGetLessonByLessonId = createAsyncThunk(
  "teacher/get/lessonByLessonId",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await lessonsService.teacherGetLessonByLessonId(data);
      const expertDetails = await expertsService.getTeacherById(
        res.data.lesson.expert_id
      );
      return { res, expertDetails };
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const reserveLesson = createAsyncThunk(
  "get/reserveLesson",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await lessonsService.reserveLesson(data);
      return { res };
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const cleanLessonDetails = (): AppThunk => (dispatch) => {
  dispatch(cleanDetails());
};

export const setLesson =
  (data: any): AppThunk =>
  (dispatch) => {
    dispatch(setLessonDetails(data));
  };
